import { hasValue } from '../validation';
export function maybeMap(maybeValue, mapper) {
    return hasValue(maybeValue) ? mapper(maybeValue) : maybeValue;
}
//# sourceMappingURL=maybeMap.js.map